import { Component, Input, OnInit } from '@angular/core';

import { Principal } from '../../../../shared';
import { GraphQlService } from '../../../../_services';

@Component({
    selector: 'session-detail-trainer-evaluation',
    templateUrl: 'trainer-evaluation.component.html',
    styleUrls: [
        'trainer-evaluation.component.scss',
        'evaluations.component.scss',
    ],
})
export class SessionDetailTrainerEvaluationsComponent implements OnInit {
    @Input() sessionId;
    trainerEvaluation: any;

    constructor(
        private principal: Principal,
        private graphQlService: GraphQlService
    ) {}

    async ngOnInit() {
        const isAdmin = await this.principal.hasAnyAuthority(['ROLE_ADMIN']);
        const query = isAdmin
            ? {
                  query: `
                    query ($trainingSessionId: bigint) {
                      evaluations: trainer_evaluation(
                        where: {
                          training_session_id: { _eq: $trainingSessionId }
                        }
                      ) {
                        id
                        date
                        slidesNeedUpdate: slides_need_update
                        workbookNeedsUpdate: workbook_needs_update
                        studentsHadPrerequisites: students_had_prerequisites
                        overallFeeling: overall_feeling
                        comments
                      }
                    }
                `,
                  role: 'platon/ROLE_ADMIN',
              }
            : {
                  query: `
                    query ($trainingSessionId: bigint) {
                      evaluations: trainer_evaluation(
                        where: {
                          training_session_id: { _eq: $trainingSessionId }
                        }
                      ) {
                        id
                        date
                        slidesNeedUpdate: slides_need_update
                        workbookNeedsUpdate: workbook_needs_update
                        studentsHadPrerequisites: students_had_prerequisites
                      }
                    }
                `,
                  role: 'world',
              };
        const response = await this.graphQlService
            .post({
                ...query,
                variables: { trainingSessionId: this.sessionId },
            })
            .toPromise();
        this.trainerEvaluation = response.evaluations[0];
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/evaluations/trainer-evaluation.component.ts